// Initial form data moved out of component for reuse and easier testing
export const INITIAL_FORM_DATA = {
    productTitle: '',
    slug: '',
    description: '',
    selectedCategoryId: '',
    // single theme object for single-select mode
    selectedVoucherThemes: null,
    selectedAddOns: [],
    selectedMerchantGroupId: '',
    isFeatured: false,
    isPublished: false,
    customization: '',
    emailDelivery: false,
    smsDelivery: false,
    clientId: null
};

export const SUCCESS_MESSAGE = 'PRODUCT_ADDED_SUCCESSFULLY';

export const DEBOUNCE_DELAY = 500;

export const TOAST_MESSAGES = {
    success: 'Product created successfully!',
    error: 'Failed to create product. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
    productTitle: 'Please provide a product title.',
    description: 'Please provide a product description.',
};

export const PRODUCT_FORM_FIELDS = [
    {
        name: 'productTitle',
        label: 'Product Title',
        type: 'text',
        placeholder: 'Enter product title',
        required: true,
        validationMessage: 'Please provide a product title.',
    },
    {
        name: 'slug',
        label: 'Slug',
        type: 'text',
        placeholder: 'Enter product slug',
        required: true,
        validationMessage: 'Please provide a product slug.',

    },
    {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        placeholder: 'Enter product description',
        required: true,
        validationMessage: 'Please provide a product description.',
        rows: 5
    },
    {
        name: 'clientId',
        label: 'Client ID',
        type: 'text',
        placeholder: 'Enter Client ID',
        required: false,
    }
];

// Build backend-compatible payload from component form data
export const buildPayload = (formData = {}) => {
    const parseMerchantGroupId = (val) => {
        if (val === '' || val === null || typeof val === 'undefined') return null;
        if (typeof val === 'string') return val;
        if (typeof val === 'number') return String(val);
        return null;
    };

    const parseAddOnIds = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr
            .map(v => {
                if (typeof v === 'number') return v;
                if (typeof v === 'string') {
                    const n = Number(v);
                    return Number.isNaN(n) ? null : n;
                }
                return null;
            })
            .filter(v => v !== null);
    };

    const selectedDeliveryOptions = [];
    if (formData.emailDelivery) selectedDeliveryOptions.push('email');
    if (formData.smsDelivery) selectedDeliveryOptions.push('sms');

    return {
        title: formData.productTitle || formData.title || '',
        slug: formData.slug || '',
        clientId: formData.clientId || formData.cliendId || null,
        description: formData.description || '',
        productCategoryId: formData.selectedCategoryId || formData.productCategoryId || formData.categoryId || null,
        voucherThemeCategoryId: formData.selectedVoucherThemes
            ? (formData.selectedVoucherThemes.id || Number(formData.selectedVoucherThemes))
            : (Array.isArray(formData.voucherThemeIds) && formData.voucherThemeIds.length
                ? Number(formData.voucherThemeIds[0])
                : null),
        addOnIds: parseAddOnIds(formData.selectedAddOns || formData.addOnIds),
        merchantGroupId: parseMerchantGroupId(formData.selectedMerchantGroupId || formData.merchantGroupId),
        featured: !!formData.isFeatured || !!formData.featured,
        published: !!formData.isPublished || !!formData.published,
        deliveryOptions: selectedDeliveryOptions.join(',') || (formData.deliveryOptions || ''),
        version: "V2"
    };
};

// Validate form data and return an errors object keyed by field name
export const validateForm = (formData = {}) => {
    const errs = {};

    // Validate fields defined in constants
    PRODUCT_FORM_FIELDS.forEach(field => {
        const val = formData[field.name];
        if (field.required) {
            const empty = val === null || typeof val === 'undefined' || String(val).trim() === '' || (Array.isArray(val) && val.length === 0);
            if (empty) errs[field.name] = field.validationMessage || `${field.label} is required`;
        }
    });

    // custom selects (UI marks these required)
    if (!formData.selectedCategoryId || String(formData.selectedCategoryId).trim() === '') {
        errs.selectedCategoryId = 'Please select a category.';
    }

    if (!formData.selectedVoucherThemes || (Array.isArray(formData.selectedVoucherThemes) && formData.selectedVoucherThemes.length === 0)) {
        errs.selectedVoucherThemes = 'Please select a voucher theme.';
    }

    if (!formData.selectedAddOns || (Array.isArray(formData.selectedAddOns) && formData.selectedAddOns.length === 0)) {
        errs.selectedAddOns = 'Please select at least one add-on.';
    }

    if (!formData.selectedMerchantGroupId || String(formData.selectedMerchantGroupId).trim() === '') {
        errs.selectedMerchantGroupId = 'Please select a merchant group.';
    }

    return errs;
};
